/*
  Salon art auto-crop. The catalog's frame photos are square studio shots
  with white margins whose size depends on the art's orientation
  (landscape, square, portrait). For each piece we probe a small copy of
  the image, find the bounding box of non-white pixels, and crop the
  displayed image to exactly the framed art. Falls back to the uncropped
  (matted) look when the probe fails (CORS, decode errors).
*/
(() => {
  const PROBE = 64;
  const WHITE = 244;

  const probeUrl = (src) => {
    try {
      const u = new URL(src, window.location.href);
      u.searchParams.set('width', '120');
      return u.toString();
    } catch (e) {
      return src;
    }
  };

  const cropOne = (img) => {
    const wrap = img.closest('.sal-art--cropped');
    if (!wrap || wrap.dataset.salCropped) return;
    const probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = () => {
      const c = document.createElement('canvas');
      c.width = PROBE;
      c.height = PROBE;
      const ctx = c.getContext('2d');
      ctx.drawImage(probe, 0, 0, PROBE, PROBE);
      let data;
      try {
        data = ctx.getImageData(0, 0, PROBE, PROBE).data;
      } catch (e) {
        return; // tainted canvas: keep matted look
      }
      let minX = PROBE, minY = PROBE, maxX = -1, maxY = -1;
      for (let i = 0; i < PROBE * PROBE; i++) {
        const o = i * 4;
        if (data[o] > WHITE && data[o + 1] > WHITE && data[o + 2] > WHITE) continue;
        const px = i % PROBE;
        const py = (i / PROBE) | 0;
        if (px < minX) minX = px;
        if (px > maxX) maxX = px;
        if (py < minY) minY = py;
        if (py > maxY) maxY = py;
      }
      if (maxX <= minX || maxY <= minY) return;
      // fractions of the square image occupied by the art + frame
      const w = (maxX - minX + 1) / PROBE;
      const h = (maxY - minY + 1) / PROBE;
      if (w > 0.98 && h > 0.98) return; // nothing to crop
      wrap.style.aspectRatio = (w / h).toFixed(3);
      // displayed image width relative to wrapper; margins shift the bbox into view
      img.style.maxWidth = 'none';
      img.style.width = (100 / w).toFixed(2) + '%';
      img.style.height = 'auto';
      img.style.objectFit = 'unset';
      img.style.transform = 'none';
      // both margins use (100 / w): source photos are square, so displayed
      // height equals displayed width, and CSS % margins resolve against
      // the containing block width on both axes
      img.style.marginLeft = '-' + ((minX / PROBE) * (100 / w)).toFixed(2) + '%';
      img.style.marginTop = '-' + ((minY / PROBE) * (100 / w)).toFixed(2) + '%';
      wrap.dataset.salCropped = '1';
    };
    probe.src = probeUrl(img.currentSrc || img.src);
  };

  const run = () => {
    document.querySelectorAll('.sal-art--cropped img').forEach(cropOne);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
